/**
 * parent-server-time-service AMD module that returns riqServerTimeService implementation.
 */
define([
  'js/aofl-js/0.8.0/aofl-modules/__build/aofljs.min'
], function riqServerTimeServiceImplModule(aoflModules) {
  'use strict';
  var storeService = aoflModules.store;
  var ServerTime = aoflModules.ServerTime;
  var riqServerTimeServiceImpl = function riqServerTimeServiceImpl() {
    var getDelta = function() {
      return 0;
    };

    var getAdjustedTime = function getAdjustedTime() {
      return Math.round(Date.now() / 1000);
    };

    // Why this?
    var unsubscribe = storeService.subscribe(function() {
      var state = storeService.getState();
      // TODO this used to check for token check why and update it!
      if (state.profile !== null) {
        var serverTime = new ServerTime('readingIq');
        getDelta = serverTime.getDelta.bind(serverTime);
        getAdjustedTime = serverTime.getAdjustedTime.bind(serverTime);
        unsubscribe();
      }
    });

    return {
      getDelta: function() {
        return getDelta();
      },
      getAdjustedTime: function() {
        return getAdjustedTime();
      }
    };
  };

  return riqServerTimeServiceImpl;
});
